// extracted by css-extract-rspack-plugin
export default {"chartNote":"ChartNote-module__chartNote___SsFXd","error":"ChartNote-module__error___kLHyi"};